import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

const messages = defineMessages({
  max: {
    id: 'bookings.buyer.email.max',
    defaultMessage: 'The email can be up to 255 characters'
  },
  format: {
    id: 'bookings.buyer.email.format',
    defaultMessage: 'The format is incorrect'
  },
  length: {
    id: 'bookings.form.phone.length',
    defaultMessage: 'The phone should have 10 numbers'
  }
})
export const schema = (intl: IntlShape): yup.AnyObjectSchema => {
  return yup.object().shape({
    phone: yup.string().length(10, intl.formatMessage(messages.length)),
    email: yup.string().max(255, intl.formatMessage(messages.max)).email(intl.formatMessage(messages.format))
  })
}
